import api from '@/helpers/api';

export default {
  /**
  * Retrieves web settings on page load or when socket event is received.
  */
  fetchSettings({ commit, dispatch }) {
    return api('GET', 'system/settings', null, null, 'w')
      .then((response) => {
        commit('SET_SYSTEM_SETTINGS', response.data);
        dispatch('pusher/resetPusher', null, { root: true });
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  /**
  * Retrieves desktop settings on page load or when socket event is received.
  */
  fetchDesktopSettings({ commit, dispatch }) {
    return api('GET', 'system/settings', null, null, 'd')
      .then((response) => {
        commit('SET_SYSTEM_SETTINGS', { ...response.data, desktop: true });
        dispatch('pusher/resetPusher', null, { root: true });
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchNewMessages({ commit, rootState }) {
    if (!rootState.organisation || !rootState.organisation.currentOrganisation || !rootState.organisation.currentOrganisation.id) {
      return Promise.resolve();
    }
    return api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/system/message`, null, null, 'w')
      .then((response) => {
        // commit('SET_SYSTEM_MESSAGES', response.data);  // No need to save this data
        return response;
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchWhatsAppSettings({ commit }) {
    api('GET', '/whatsapp/settings', null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('SET_WA_SETTINGS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  hideAnnouncement({ commit }, local = false) {
    if (local) {
      localStorage.setItem('feature:AIassistant:6', false);
    }
    commit('HIDE_ANNOUNCEMENT');
  },
  showAnnouncement({ commit }) {
    // localStorage.setItem('feature:AIassistant:5', true);
    commit('SHOW_ANNOUNCEMENT');
  },
  setFullWindow({ commit }, payload) {
    commit('SET_FULL_WINDOW', payload);
  },
};
